// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/commentView/CommentPopover.scss
// module id = 1958
// module chunks = 0